import React, { Component } from 'react'
import styled from 'styled-components'
import { Droppable } from 'react-beautiful-dnd'
import { graphql, compose, withApollo } from 'react-apollo'
import Topic from './Topic'
import CreateHighlight from '../../queries/CreateHighlight'
import UpdateHighlight from '../../queries/UpdateHighlight'
import DeleteTopicConfirmationModal from '../../modals/DeleteTopicConfirmationModal'
import Modal from '../../../common/Modal'

const Container = styled.div`
  margin: 8px;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`
const Title = styled.h3`
  height: 19px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  display: flex;
`
const AddTopic = styled.div`
  display: flex;
  height: 19px;
  width: 105px;
  color: #3399CC;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  cursor: pointer;
`
const TopicsList = styled.div`
  transition: background-color 0.2s ease;
  background-color: ${props => (props.isDraggingOver ? '#F6F8FA' : 'white')};
`

class Category extends Component {
  constructor(props) {
    super(props)
    this.state = {
      category: props.category,
      topics: props.topics,
      isDeleteModalOpen: false,
      deleteHighlightId: null,
    }
  }

  onAddNewTopicClick = () => {
    const { topics } = this.state
    const newTopic = { rid: null, document: null, draft: true, predefined: false, category: this.props.category.id }
    topics.push(newTopic)
    this.updateTopics(topics)
  }

  toggleDeleteModal = () => {
    this.setState({ isDeleteModalOpen: !this.state.isDeleteModalOpen })
  }

  renderDeleteConfirmation = () => {
    const { isDeleteModalOpen, deleteHighlightId } = this.state
    return (
      <Modal light isModalOpen={isDeleteModalOpen}>
        <DeleteTopicConfirmationModal
          highlightId={deleteHighlightId}
          toggleModal={this.toggleDeleteModal}
          updateTopicList={this.updateTopicList}
          onCloseClick={this.onCloseClick}
        />
      </Modal>
    )
  }

  updateTopicList = () => {
    const { topics, deleteHighlightId } = this.state
    const newTopicList = topics.filter(({rid: topicId}) => topicId !== deleteHighlightId)
    this.updateTopics(newTopicList)
  }

  onDeleteTopic = highlightId => {
    this.toggleDeleteModal()
    this.setState({
      deleteHighlightId: highlightId,
    })
    this.renderDeleteConfirmation()
  }

  componentWillReceiveProps({topics, category}) {
    if (topics.length != 0) {
      this.setState({
        ...this.state,
        category,
        topics,
      })
    }
  }

  onSaveNewTopic = ({ draft, editorTitle, editorContent, files}) => {
    const { createHighlight, loanId } = this.props
    const { id, guarantorId } = this.state.category
    const { topics } = this.state
    return createHighlight({
      variables: {
        input: {
          loanId,
          category: id,
          topic: editorTitle,
          explanation: editorContent,
          draft,
          guarantorId,
          files,
        }
      },
      update: async (store, { data: { createHighlight: { highlight } } }) => {
        topics[topics.length - 1] = highlight;
        this.updateTopics(topics)
      }
    })
  }

  onUpdateExistingTopic = ({ rid, draft, editorTitle, editorContent, files, deleteFiles }) => {
    const { updateHighlight } = this.props
    const { topics } = this.state

    const newFiles = files.filter(file => file instanceof File)

    return updateHighlight({
      variables: {
        input: {
          highlightId: rid,
          topic: editorTitle,
          explanation: editorContent,
          draft,
          files: newFiles,
          deleteFiles,
        }
      },
      update: async (store, { data: { updateHighlight: { highlight } } }) => {
        topics.map((topic, index) => {
          if (topic.rid === highlight.rid) {
            topics[index] = highlight
          }
        })
        this.updateTopics(topics)
      }
    })
  }

  updateTopics = topics => {
    this.setState({
      ...this.state,
      topics,
    })
  }

  onCloseClick = () => {
    const { topics } = this.state
    this.updateTopics(topics.filter(({ rid }) => rid !== null))
  }

  render() {
    const { topics, category } = this.state
    const { title, id } = category
    const { loanId, isBankUser, isDropDisabled } = this.props
    return (
      <Container>
        <Header>
          <Title>{title}</Title>
          {!isBankUser && (
            <AddTopic onClick={this.onAddNewTopicClick}>+ Add new topic</AddTopic>
          )}
        </Header>

        <Droppable
          droppableId={title}
          isDropDisabled={isDropDisabled}>
          {(provider, snapshot) => (
            <TopicsList
              innerRef={provider.innerRef}
              {...provider.droppableProps}
              isDraggingOver={snapshot.isDraggingOver}
            >
              {(topics.map((topic, index) => (
                <Topic
                  key={topic.rid}
                  topic={topic}
                  index={index}
                  loanId={loanId}
                  category={id}
                  isBankUser={isBankUser}
                  onCloseClick={this.onCloseClick}
                  onSaveNewTopic={this.onSaveNewTopic}
                  onUpdateExistingTopic={this.onUpdateExistingTopic}
                  onDeleteTopic={this.onDeleteTopic}
                  published={!topic.draft}/>
                ))
              )}
              {provider.placeholder}
            </TopicsList>
          )}
        </Droppable>
        {this.renderDeleteConfirmation()}
      </Container>
    )
  }
}

export { Category }

export default compose(
  graphql(CreateHighlight, {
    name: 'createHighlight'
  }),
  graphql(UpdateHighlight, {
    name: 'updateHighlight'
  }),
  withApollo
)(Category)
